import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})



export class GestorService {
  id: any
  gestores: any=[]

  constructor() { }

  getAllGestores(){
    return gql`
      query getAllGestores {
          gestors(sort: "createdAt:DESC") {
            id
            nombre
            cif
            nombreContacto
            mailContacto
            estado
            nima
            documentos {
              estado 
              tipo
            }
            contratistaContacto {
              nombre
              mail
              contratista
            }
          }
        }
    `;
  }

  getAllGestoresDoughtnout(){
    return gql`
      query getAllGestores {
          gestors {
            id
            estado
            documentos{
              id
              tipo
              estado
            }
          }
        }
    `;
  }

  getAllGestoresYellow(){
    return gql`
      query getAllGestores {
          gestors (
            where: {
              estado: "amarillo"
            }
          ){
            id
            nombre
            cif
            nombreContacto
            mailContacto
            estado
            documentos {
              estado 
              tipo
            }
            contratistaContacto {
              nombre
              mail
              contratista
            }
          }
        }
    `;
  }

  getAllGestoresRed(){
    return gql`
      query getAllGestores {
          gestors (
            where: {
              estado: "rojo"
            }
          ){
            id
            nombre
            cif
            nombreContacto
            mailContacto
            estado
            documentos {
              estado 
              tipo
            }
            contratistaContacto {
              nombre
              mail
              contratista
            }
          }
        }
    `;
  }

  getAllGestoresGreen(){
    return gql`
      query getAllGestores {
          gestors (
            where: {
              estado: "verde"
            }
          ){
            id
            nombre
            cif
            nombreContacto
            mailContacto
            estado
            documentos {
              estado 
              tipo
            }
            contratistaContacto {
              nombre
              mail
              contratista
            }
          }
        }
    `;
  }


  getGestorById(){
    return gql`
      query getGestorById($id: ID!) {
          gestor(id: $id) {
            id
            nombre
            cif
            codigo
            nima
            nombreContacto
            mailContacto
            contratistas {
              nombreComercial
            }
            contratistaContacto {
              nombre
              mail
              contratista 
            }
            comentariosAutorizacion1{
              causa
              fecha
              comentario
            }
            comentariosAutorizacion2{
              causa
              fecha
              comentario
            }
            comentariosAutorizacion3{
              causa
              fecha
              comentario
            }
            comentariosAutorizacion4{
              causa
              fecha
              comentario
            }
            comentariosAutorizacion5{
              causa
              fecha
              comentario
            }
          }
        }
    `;
  }

  getGestor(){
    return gql`
      query getGestor($id: ID!) {
        gestor(id: $id) {
          id
          centros {
            id
            contratista{
              id
            }
          }
        }
      }
    `;
  }

  updateGestorCentros(){
    return gql`
      mutation updateGestor($input: updateTransportistaInput!) {
        updateGestor(input: $input) {
          gestor {
            id
            centros {
              id
            }
          }
        }
      }
    `;
  }

  addGestor(){
    return gql`
      mutation createGestor($input: createGestorInput!) {
      createGestor(input: $input) {
        gestor {
          id
        }
      }
    }
    `;
  }

  updateGestor(){
    return gql`
      mutation updateGestor($input: updateGestorInput!) {
        updateGestor(input: $input) {
          gestor {
            id
          }
        }
      }
    `;
  }

  deleteGestor(){
    return gql`
      mutation deleteGestor($input: deleteGestorInput!) {
        deleteGestor(input: $input) {
          gestor {
            id
          }
        }
      }
    `;
  }

  setIdGestor(id:any){
    this.id = id; 
  }

  getIdGestor(){
   let temp = this.id;
    this.clearIdGestor();
    return temp;
  }

  clearIdGestor(){
    this.id = undefined;
  }

  setGestores(gestores:any){
    this.gestores = gestores; 
  }

  getGestores(){
   let temp = this.gestores;
    this.clearGestores();
    return temp;
  }

  clearGestores(){
    this.gestores = [];
  }
}
